// const obj = { name: 'obj' };
// const obj2 = { name: 'obj2' };
// export default { obj, obj2 };

export const TzsciQueryType_Question="TzsciQueryType_Question";
export const TzsciQueryType_KB="TzsciQueryType_KB";
export const TzsciQueryType_Doctor="TzsciQueryType_Doctor";
export const TzsciQueryType_News="TzsciQueryType_News";

export const TzsciCode_AnswerSelectType=
    {
        單選:"single",
        單選及其他:"singleWithOther",
        多選:"multi",
        多選及其他:"multiWithOther",
    };


// // export const QueryType_MenuTop="QueryType_MenuTop";
// // export const QueryType_MenuLeft="QueryType_MenuLeft";
//
// // var testValue="abc";
// export default const variable = 'value';
//
// export default {
//     // var testValue2="abc";
//
//     test(){
//
//     }
//     // QueryType_Index_1_BannerImage
//     // QueryType_Index_2_Team
//     // export const QueryType_Index_1_BannerImage="QueryType_Index_1_BannerImage";
//     // export const QueryType_Index_2_Team="QueryType_Index_2_Team";
//     // export const QueryType_Index_3_Op="QueryType_Index_3_Op";
//     // export const QueryType_Index_4_Action="QueryType_Index_4_Action";
//     // export const QueryType_Index_5_3482="QueryType_Index_5_3482";
//     // export const QueryType_Index_6_Images="QueryType_Index_6_Images";
//     // export const QueryType_Index_7_Videos="QueryType_Index_7_Videos";
//     //
//     // export const QueryType_Menu="QueryType_Menu";
// }
